module.exports = __webpack_public_path__ + "static/media/checked-icon-blue.bbb5c41f.svg";